export const exploreProducts = [
  {
    id: "product-1",
    imgUrl: "/planet-01.png",
    title: "egift",
  },
  {
    id: "product-2",
    imgUrl: "/planet-02.png",
    title: "subscriptions",
  },
  {
    id: "product-3",
    imgUrl: "/planet-03.png",
    title: "recharges",
  },
  {
    id: "product-4",
    imgUrl: "/planet-04.png",
    title: "gaming_cards",
  },
  {
    id: "product-5",
    imgUrl: "/planet-05.png",
    title: "software",
  },
];

export const startingFeatures = ["firststep", "secondstep", "thirdstep"];

export const newFeatures = [
  {
    imgUrl: "/vrpano.svg",
    title: "title1",
    subtitle: "subtitle1",
  },
  {
    imgUrl: "/head.svg",
    title: "title2",
    subtitle: "subtitle2",
  },
];

export const insights = [
  {
    imgUrl: "/planet-06.png",
    title: "We are in 9 Wilayas around the country",
    subtitle:
      "We are covering i middle region of the country & still expanding thanks to our dealers who promote our partnership locally.",
  },
  {
    imgUrl: "/planet-07.png",
    title: "7 tips to easily master the madness of the Metaverse",
    subtitle:
      "Vitae congue eu consequat ac felis donec. Et magnis dis parturient montes nascetur ridiculus mus. Convallis tellus id interdum",
  },
  {
    imgUrl: "/planet-08.png",
    title: "With one platform you can explore the whole world virtually",
    subtitle:
      "Quam quisque id diam vel quam elementum. Viverra nam libero justo laoreet sit amet cursus sit. Mauris in aliquam sem",
  },
];

export const socials = [
  {
    name: "twitter",
    url: "/images/home-page/twitter.svg",
    href: "",
  },
  {
    name: "linkedin",
    url: "/images/home-page/linkedin.svg",
    href: "https://www.linkedin.com/company/digital-home-dz/",
  },
  {
    name: "instagram",
    url: "/images/home-page/instagram.svg",
    href: "",
  },
  {
    name: "facebook",
    url: "/images/home-page/facebook.svg",
    href: "https://www.facebook.com/digitalhomedz",
  },
];
